import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import { Icon } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { UiHelper } from '../common/helpers/UiHelper';
import { Helper } from '../common/helpers/Helper';
import { BaseEntityPage } from '../common/components/BaseEntityPage';
import { MsgDialog } from '../components/MsgDialog';
import { ReferralComponent } from '../components/ReferralComponent';
import { CatHeader } from '../components/CatHeader';
import { CommonStyles } from '../styles/Styles';
import { AppTheme, AppStyles } from '../styles/AppTheme';
import { AppConfig } from '../AppConfig';
import { dataItem } from '../data/data';
import { Controller } from '../common/Controller';
import { AppHelper } from '../helpers/AppHelper';

export class SurveyHome extends BaseEntityPage {
  constructor(props) {
    super(props);
    this.state = {
      fetchState: ApiHelper.State.LOADING,
      referralDialog: false,
      optionals: [],
      baselines: [],
      mandatory: [],
    },
    this.referralData = dataItem.referralData
  }

  componentDidMount() {
    this.fetchItems();
  }

  fetchItems() {
    ApiHelper.call(
      {
        method: 'GET',
        endPoint: ApiHelper.makeUrlPath(['/miscs/quiz-progress'],
          {
            quizId: AppConfig.quizId
          }
        )
      },
      function (err, results) {
        if (err) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }

        let surveySections = []
        if (results.sections) {
          const appUser = Controller.get().userMgr().getAppUser()
          const age = AppHelper.calculateAgeBasedonUserCreatedTs(appUser)
          if(age < 18 && age >= 13 && appUser.preferedQSections) {
            results.sections = results.sections.filter((item) => appUser.preferedQSections.includes(item.id) || item.baseline === 'MANDATORY')
          }
          surveySections = results.sections.sort(function (a, b) { return (Number(a.order) > Number(b.order)) ? 1 : ((Number(b.order) > Number(a.order)) ? -1 : 0); })
        }

        const baselines = []
        const mandatory = []
        const optionals = []
        if (results && results.sections) {
          for (const item of results.sections) {
            if (item.baseline === 'YES' || item.baseline === 'BASELINE') {
              baselines.push(item)
            } else if (item.baseline === 'MANDATORY') {
              mandatory.push(item)
            } else {
              optionals.push(item)
            }
          }
        }

        this.setState({
          surveySections: surveySections,
          baselines: baselines,
          mandatory: mandatory,
          optionals: optionals,
          fetchState: ApiHelper.State.READY
        })
      }.bind(this))
  }

  checkSectionStatus = (item) => {
    if (!item.subsections || item.subsections.length === 0) {
      return null
    }

    let oneSurveyComplete = false;
    let allSurveyComplete = true
    for (const sub of item.subsections) {
      if (!sub.complete && sub.intro !== 'YES') {
        allSurveyComplete = false
      }
      if (sub.complete) {
        oneSurveyComplete = true
      }
    }
    if (oneSurveyComplete && allSurveyComplete) {
      return 'COMPLETE'
    }
    if (oneSurveyComplete && !allSurveyComplete) {
      return 'PARTIAL'
    }

    return null
  }

  referralDialogOpen = () => {
    this.setState({
      referralDialog: true
    })
  }

  referralDialogClose = () => {
    this.setState({
      referralDialog: false
    })
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  renderSurveyContainer = (items, catType) => {
    if (!items || items.length === 0) {
      return ''
    }

    return (
      <div className={css(Styles.tileOuterContainer)}>
        <CatHeader catType={catType}/>
        <Grid container spacing={3}>
          {items &&
            items.length > 0 &&
            items.map(item => {
              const sectionStatus = this.checkSectionStatus(item)
              return (
                <Grid item xs={12} sm={6} key={item.id}>
                  <Link to={{ pathname: '/survey-sections/' + item.id, state: { item: item } }}
                    className={css(Styles.link)}>
                    <div
                      className={css(Styles.tileContainer)}>
                      <div className={css(Styles.tileImgContainer)}>
                        <img
                          src={item.image}
                          className={css(Styles.tileImg)}
                        />
                      </div>
                      <p className={css(Styles.tileTitle)}>{item.title}</p>
                      {(sectionStatus === 'COMPLETE' || sectionStatus === 'PARTIAL') &&
                        <div
                          style={{
                            backgroundColor: sectionStatus === 'COMPLETE' ? '#71C9AF' : '#e5bc6a'
                          }}
                          className={css(Styles.completedTile)}>
                          <div className={css(Styles.completedIconContainer)}>
                            <Icon className={css(Styles.completedIconContent)}>done</Icon>
                          </div>
                        </div>
                      }
                    </div>
                  </Link>
                </Grid>
              )
            })
          }
        </Grid>
      </div>
    )
  }

  readyView() {
    return (
      <div className={css(AppStyles.containerNarrow, Styles.containerNarrow)}>
        <div className={css(CommonStyles.headerContainer)}>
          <p className={css(CommonStyles.headerContent)}>Survey Home</p>
        </div>

        <div className={css(Styles.divider)}></div>

        {this.renderSurveyContainer(this.state.mandatory, dataItem.surveyCatInfo.essential.catType)}
        {this.renderSurveyContainer(this.state.optionals, dataItem.surveyCatInfo.optional.catType)}
        {this.renderSurveyContainer(this.state.baselines, dataItem.surveyCatInfo.recommended.catType)}

        {(!this.state.surveySections || this.state.surveySections.length === 0) &&
          UiHelper.emptyView('No surveys found')
        }
        <div className={css(Styles.referralIconContainer)}>
          <div className={css(Styles.referralIconImgContainer)} onClick={() => this.referralDialogOpen()}>
            <img src={require('../assets/images/referralIcon.png')} className={css(Styles.imgContainer)} />
          </div>
        </div>

        <ReferralComponent
          showDialog={this.state.referralDialog}
          closeDialog={this.referralDialogClose}
        />

      </div>
    );
  }
}

const tileWidth = 328;
const tileHeight = 153;
const Styles = StyleSheet.create({
  containerNarrow: {
    height: 'unset',
    alignItems: 'center',
    width: '100%'
  },
  /*tileOuterContainer: {
    maxWidth: 700,
    marginTop: 70,
    marginBottom: 50,
    '@media (max-width: 767px)': {
      marginTop: 20,
    },
    '@media(min-width: 768px) and (max-width: 1023px)': {
      marginTop: 20,
    },
  },*/
  tileOuterContainer: {
    maxWidth: 700,
    width: '90%',
    marginTop: 20,
    marginBottom: 20,
    border: '1px solid' + AppTheme.primaryColor,
    padding: 50,
    paddingTop: 20,
    borderRadius: 50,
    '@media (max-width: 767px)': {
      marginTop: 20,
      padding: 20,
      paddingTop: 15,
    },
    '@media(min-width: 768px) and (max-width: 1023px)': {
      marginTop: 20,
      width: '80%',
    },
  },
  tileContent: {
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      alignItems: 'center'
    }
  },
  tileInnerContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    '@media (max-width: 767px)': {
      maxWidth: '100%',
      maxHeight: '100%'
    }
  },
  tileContainer: {
    cursor: 'pointer',
    overflow: 'hidden',
    backgroundColor: AppTheme.tertiaryBg,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    //width: tileWidth,
    width: '100%',
    minHeight: tileHeight,
    height: tileHeight,
    borderRadius: 12,
    boxShadow: '2px 2px 3px #B5B5B5',
    position: 'relative',
    '@media (max-width: 767px)': {
      //minHeight: 140,
      minHeight: tileHeight,
      height: tileHeight,
      //minWidth: 280,
      //width: '100%',
      //height: '100%',
    }
  },
  completedTile: {
    //width: tileWidth - 10,
    width: '97%',
    height: tileHeight - 10,
    position: 'absolute',
    zIndex: 1,
    opacity: .43,
    borderRadius: 12,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '@media (max-width: 767px)': {
      width: '96%',
      //height: '93%'
      height: tileHeight - 15,
    },
    /*'@media(min-width: 768px) and (max-width: 1023px)': {
      width: '98%',
      height: '97%'
    },*/
  },
  completedIconContainer: {
    //border: '6px solid' + AppTheme.secondaryBg,
    //borderRadius: '50%'
  },
  completedIconContent: {
    border: '5px solid' + AppTheme.secondaryBg,
    borderRadius: '50%',
    fontSize: 40,
    color: AppTheme.secondaryBg
  },
  tileTitle: {
    //wordBreak: 'break-word',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    flex: .5,
    color: AppTheme.textColor,
    fontSize: AppTheme.fontSize,
    margin: '0px 15px',
    textTransform: 'uppercase'
  },
  tileImgContainer: {
    flex: .5,
    maxWidth: '100%',
    display: 'flex',
    height: '100%',
    alignItems: 'center'
  },
  tileImg: {
    //maxWidth: '100%',
    //maxHeight: '100%',
    maxWidth: '90%',
    maxHeight: '90%',
    borderRadius: 12
  },
  link: {
    width: '100%',
    textDecoration: 'none'
  },
  referralIconContainer: {
    position: 'fixed',
    bottom: 80,
    right: 20,
    zIndex: 1,
    '@media (max-width: 767px)': {
      bottom: 30,
      right: 15,
    },
  },
  referralIconImgContainer: {
    width: 100,
    height: 100,
    cursor: 'pointer',
    '@media (max-width: 767px)': {
      width: 60,
      height: 60,
    },
  },
  imgContainer: {
    maxHeight: '100%',
    maxWidth: '100%'
  },
  tileTitleContainer: {
    fontSize: 23,
    color: AppTheme.textColorVariant,
    margin: AppTheme.pMargin,
    marginBottom: 20,
    textAlign: 'center',
  },
  divider: {
    marginTop: 70,
    '@media (max-width: 1023px)': {
      marginTop: 20,
    },
  }
})



// WEBPACK FOOTER //
// ./src/screens/SurveyHome.js